import { createSlice } from '@reduxjs/toolkit';

export const citySlice = createSlice({
  name: 'city',
  initialState: {
    cityName: '',
    pincode: ''
  },
  reducers: {
    pushCityInfo: (state, action) => {
      state.cityName = action.payload;
      state.pincode = action.payload;
    },
    popCityInfo: (state) => {
      state.cityName = '';
      state.pincode = '';
    }
  },
});

export const { pushCityInfo, popCityInfo } = citySlice.actions;

export const selectCityName = (state) => state.city.cityName;
export const selectCityPincode = (state) => state.city.pincode;

export default citySlice.reducer;
